import React, { useState, useEffect } from "react"
import "./faq.scss"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import CollapseFaq from "../collapse-faq/collapse-faq"
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'

const Faq = props => {
  const { faq, mobile } = props
  const [activeTab, setactiveTab] = useState(0)
  const [activeCollapse, setActiveCollapse] = useState(0)

  const dataLayerContacto = (option) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Contactanos',
      category: 'contactanos',
      action: 'click',
      label: option,
      sub_category: 'Preguntas frecuentes',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  useEffect(() => {
    var fullPath = window.location.href

    var lastPathItem = fullPath.split("/")[fullPath.split("/").length - 1]

    if (lastPathItem === "#f-mail") {
      setActiveCollapse(4)
      window.scrollTo(0, 420)
    } else if (lastPathItem === "#f-mail-change") {
      setActiveCollapse(6)
      window.scrollTo(0, 600)
    } else if (lastPathItem === "#f-date-change") {
      setActiveCollapse(5)
      window.scrollTo(0, 600)
    }
    if (lastPathItem === "#entrykey") {
      setactiveTab(1)
      setActiveCollapse(1)
      if (mobile) {
        window.scrollTo(0, 610)
      } else {
        window.scrollTo(0, 540)
      }
    }
  }, [])
  return (
    <section className="f-faq-section">
      <TitleTab
        title="Preguntas frecuentes"
        className="f-TitleTab f-TitleTab-blue"
      />
      <div className="f-buttons-category-container">
        {faq.map((faqItem, index) => {
          return (
            <div
              className={
                "f-fake-button " +
                (activeTab === index ? "f-button-active" : "")
              }
              key={index}
              onClick={() => {
                setactiveTab(index)
                setActiveCollapse(0)
                dataLayerContacto(faqItem.nombreEtiqueta)
              }}
            >
              {faqItem.nombreEtiqueta}
            </div>
          )
        })}
        <span className="f-spacer" />
      </div>
      <CollapseFaq
        activeCollapse={activeCollapse}
        setActiveCollapse={setActiveCollapse}
        options={faq[activeTab].referenciasDeLaEtiqueta}
      />
    </section>
  )
}
export default Faq
